/*
import {
  hf,
  ht,
  cr,
  a,
  BoxC,
  BtnC,
  GridC,
  MsgC,
  TextC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ht from './_ht';
import * as hf from './_hf';

import * as IcvI11a from './icvI11___Ti';

export const N = (pz: {
  sPz: ht.dz,
}) => {

  const _rows = [];
  const _cellCs = [
    {
      boxStlz: a('f/0.25'),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          abtType: 'lblStfz',
          textz: {
            pfx: 'ID',
          }
        })
      ]
    },
    {
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          abtType: 'lblStfz',
          textz: {
            pfx: '時間帯区分名'
          }
        })
      ]
    },
    {
      boxStlz: a('f/0.25'),
      oClds: [
      ]
    },
  ];

  _rows.push(
    {
      cellCs: _cellCs
    },
  );
  hf.getRng(10).map( ( _nIdx: ht.n ) => {
    const _cellCs = [
      {
        boxStlz: a('f/0.25'),
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            textz: {
              pfx: `${_nIdx}`,
            }
          })
        ]
      },
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            textz: {
              pfx: `時間帯区分${_nIdx}`
            }
          })
        ]
      },
      {
        boxStlz: a('f/0.25'),
        oClds: [
          cr.c(BtnC.N, {
            key: -10,
            abtType: 'cfmStfz',
            lblCz: {
            },
            pslPtyz: {
              onPress: () => {
                pz.sPz.set({
                  steps: [1],
                  phs: 'dpy'
                })
              }
            },
          })
        ]
      },
    ];
    _rows.push(
      {
        cellCs: _cellCs
      },
    )
  });

  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'bdyCmnz',
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'barFtnStfz',
          boxStlz: a(`mb/2`),
        }),

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'cttCmnz',
          oClds: [

/*
            cr.c(MsgC.N, {
              key: -10,
              abtType: 'cttCmnz',
              boxStlz: a('mb/2'),
              cz: {
                ls: [
                  {
                    mkrCz: {
                      textz: {
                        pfx: _lblz.msgz.topz.mkr,
                      }
                    },
                    msgCz: {
                      textz: {
                        pfx: _lblz.msgz.topz.msg,
                      }
                    }
                  },
                ]
              },
            }),
*/

            cr.c(IcvI11a.L, {
              key: -30,
              sPz: pz.sPz,
            }),

            cr.c(IcvI11a.B, {
              key: -40,
              sPz: pz.sPz,
              cz: {
                lblz: pz.sPz.crt.lblz,
                sc: 'gn7',
                onPrsBack: () => {
                  cr.moveTo({
                    pageName: 'icvHomeS40Rz',
                  });
                }
              }
            })

          ]
        })

      ]
    })
  );
};
